import { paragraphSpec as e } from "./nodes/paragraph-spec.js";
import { smallSpec as o } from "./nodes/small-spec.js";
import { subheading4Spec as t, subheading3Spec as r, subheadingSpec as i, headingSpec as p } from "./nodes/heading-spec.js";
import { calloutSpec as m } from "./nodes/callout-spec.js";
import { codeBlockSpec as c } from "./nodes/code-block-spec.js";
import { videoFileSpec as l } from "./nodes/video-file-spec.js";
import { audioFileSpec as a } from "./nodes/audio-file-spec.js";
import { imageSpec as n } from "./nodes/image-spec.js";
import { videoSpec as S } from "./nodes/video-spec.js";
import { buttonSpec as s } from "./nodes/button-spec.js";
import { tableRowSpec as d, tableCellSpec as f, tableSpec as u } from "./nodes/table-spec.js";
import { listItemSpec as b, nestedListItemSpec as g, unorderedNestedListSpec as h, orderedNestedListSpec as k, unorderedListSpec as L, orderedListSpec as B } from "./nodes/list-spec.js";
import { hardBreakSpec as w } from "./nodes/hard-break-spec.js";
import { templateSpec as C } from "./nodes/template-spec.js";
import { mentionSpec as F } from "./nodes/mention-spec.js";
import { aiPromptDataSpec as I } from "./nodes/ai-prompt-data-spec.js";
import { htmlSpec as v } from "./nodes/html-spec.js";
import { horizontalRuleSpec as x } from "./nodes/horizontal-rule-spec.js";
import { ifElseStatementSpec as E } from "./nodes/if-else-statement-spec.js";
import { messengerCardSpec as N } from "./nodes/messenger-card-spec.js";
import { markerSpec as R } from "./nodes/marker-spec.js";
import { placeholderSpec as D } from "./nodes/placeholder-spec.js";
import { twitterFollowButtonSpec as y } from "./nodes/twitter-follow-button-spec.js";
import { facebookLikeButtonSpec as z } from "./nodes/facebook-like-button-spec.js";
import { socialSpec as P } from "./nodes/social-spec.js";
import { spacerSpec as T } from "./nodes/spacer-spec.js";
import { collapsibleSectionSummarySpec as j, collapsibleSectionContentSpec as q, collapsibleSectionSpec as A } from "./nodes/collapsible-section-spec.js";
import { inlineImageSpec as G } from "./nodes/inline-image-spec.js";
import { unsupportedElementSpec as H } from "./nodes/unsupported-element-spec.js";
import { imageTextSpec as J } from "./nodes/image-text-spec.js";
const he = {
  doc: {
    content: "(block | list | table)+"
  },
  singleBlockDoc: {
    content: "(block | list | table)"
  },
  text: {
    group: "inline"
  },
  paragraph: e,
  hardBreak: w,
  template: C,
  mention: F,
  aiPromptData: I,
  html: v,
  horizontalRule: x,
  orderedList: B,
  unorderedList: L,
  listItem: b,
  heading: p,
  subheading: i,
  subheading3: r,
  subheading4: t,
  small: o,
  codeBlock: c,
  ifElseStatement: E,
  image: n,
  inlineImage: G,
  videoFile: l,
  audioFile: a,
  video: S,
  button: s,
  messengerCard: N,
  marker: R,
  table: u,
  tableRow: d,
  tableCell: f,
  orderedNestedList: k,
  unorderedNestedList: h,
  nestedListItem: g,
  placeholder: D,
  twitterFollowButton: y,
  facebookLikeButton: z,
  social: P,
  spacer: T,
  callout: m,
  collapsibleSection: A,
  collapsibleSectionSummary: j,
  collapsibleSectionContent: q,
  unsupportedElement: H,
  imageText: J
};
export {
  he as nodeSpecs
};
